import { ABSENT_VALUE } from './formatMeasuredValue';

// Intl is avoided here: ICU's en-GB short month for September became "Sept", which the prototype does not use.
const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const zeroPadded = (value: number): string => String(value).padStart(2, '0');

export function formatDayAndMonth(instant: Date): string {
  return `${instant.getDate()} ${MONTH_NAMES[instant.getMonth()]}`;
}

export function formatDayAndMonthWithOtherYear(instant: Date, today: Date): string {
  const dayAndMonth = formatDayAndMonth(instant);

  return instant.getFullYear() === today.getFullYear() ? dayAndMonth : `${dayAndMonth} ${instant.getFullYear()}`;
}

export function formatDetectedAt(detectedAt: Date): string {
  const time = `${zeroPadded(detectedAt.getHours())}:${zeroPadded(detectedAt.getMinutes())}`;

  return `${formatDayAndMonth(detectedAt)} ${detectedAt.getFullYear()}, ${time}`;
}

export function formatInstantOrAbsent(instant: string | null | undefined): string {
  return instant == null ? ABSENT_VALUE : formatDetectedAt(new Date(instant));
}
